import React from 'react';
import { Container } from '../CreateMenuModal.style';
import { MenuModalChannelsTitle, ModalSection } from '../../MenuModal.style';
import SelectMarketplaceStore from './SelectMarketplaceStore/SelectMarketplaceStore';
import { MarketplaceChannelName } from '@/services/innovorder/marketplace/marketplace.type';

export type SelectMarketplaceStoreStepProps = {
    marketplace: MarketplaceChannelName;
};

export const SelectMarketplaceStoreStep: React.FunctionComponent<
    React.PropsWithChildren<SelectMarketplaceStoreStepProps>
> = ({ marketplace }) => {
    return (
        <Container>
            <ModalSection>
                <MenuModalChannelsTitle
                    type="small"
                    weight="medium"
                    text={`menu.modal.channels.${marketplace}.selectActive`}
                />
                <SelectMarketplaceStore name="marketplaceStores" marketplace={marketplace} />
            </ModalSection>
        </Container>
    );
};
